const reduxHookMiddleware = (storeEvents) => (store) => (next) => (action) => {
  const result    = next(action)
  const newState  = store.getState()

  storeEvents.dispatch(newState, action)

  return result
}


export default reduxHookMiddleware
